export default "__VITE_ASSET__Dzm0IuLi__"